import { InputTag } from 'mixs/base/input_mixin';
interface IItem {
  index: number,
  value: string,
  checked: boolean
}
class Wrap {
  scope: string;
  wrapKlass: string;
  tag: ComplexCheckSpecialReports;
  items: Array<IItem> = [];
  labels: Array<string> = [
    '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'
  ]
  constructor(tag: ComplexCheckSpecialReports, scope: string) {
    this.tag = tag;
    this.scope = scope;
    this.wrapKlass = `${scope}-wrap`;
    this.initItems()
  }
  public initItems(){
    const value = this.tag.opts.value
    if(!value){
      this.setInitItems()
    }else{
      const jsonValue = JSON.parse(value)
      const fileNames = jsonValue[this.scope]
      if(fileNames){
        this.setItemsByFilename(fileNames)
      }else{
        this.setInitItems()
      }
    }
  }
  public setItemsByFilename(fileNames){
    let items = []
    for(let i = 0; i < fileNames.length; i++){
      items.push(this.initialItem(i, fileNames[i], true))
    }
    items.push(this.initialItem(items.length))
    this.items = items
  }
  public setInitItems(){
    const jsonString = `[${this.initialJsonString(0)}]`
    this.items = JSON.parse(jsonString)
  }
  public initialJsonString(index: number){
    return JSON.stringify(this.initialItem(index))
  }
  public initialItem(index: number, value: string = '', checked: boolean = false){
    let label = this.labels[index]
    if(!label){ label = (index + 1).toString() }
    return {
      label: label,
      value: value,
      checked: checked
    }
  }
  public onChangeCheckbox(e){
    if(e.target.checked){ this.focusTextField(e.target)}
    else{
      this.clearText(e.target)
      this.updateItems()
    }
    this.tag.updateJSON()
  }
  public onChangeText(e){
    this.updateItems()
    this.tag.updateJSON()
  }
  public updateItems(){
    const length = this.items.length
    this.items = this.getNewItems();
    if(this.items.length > length){
      setTimeout(() => { this.focusNextInput() }, 1)
    }
  }
  public querySelectorAll(selector: string){
    return this.tag.querySelectorAll(`.${this.wrapKlass} ${selector}`)
  }
  public focusNextInput(){
    const textfields = this.querySelectorAll(`input[type="text"]`)
    const textfield = textfields[textfields.length - 1] as HTMLInputElement
    textfield.focus()
  }
  public getNewItems(){
    const textfields = this.querySelectorAll(`input[type="text"]`)
    let items = []
    for(let i = 0; i < textfields.length; i++){
      let item = this.initialItem(i)
      const textfield = textfields[i] as HTMLInputElement
      const value = textfield.value
      if(value == ''){ continue }
      item.value = value
      item.checked = value != '' ? true : false
      items.push(item)
    }
    items.push(this.initialItem(items.length))
    for(let i = 0; i < items.length; i++){
      let label = this.labels[i]
      if(!label){ label = (i + 1).toString() }
      items[i].label = label
    }
    return items
  }
  public clearText(checkbox){
    const textfields = this.querySelectorAll(`input[type="text"]`)
    const checkboxies = this.querySelectorAll(`input[type="checkbox"]`)
    for(let i=0; i<checkboxies.length; i++){
      if(checkboxies[i] == checkbox){
        const textfield = textfields[i] as HTMLInputElement
        textfield.value = ''
        break
      }
    }
  }
  public focusTextField(checkbox){
    const textfield = checkbox.parentElement.querySelector('input[type="text"]') as HTMLInputElement
    textfield.focus()
  }
}
export class ComplexCheckSpecialReports extends InputTag {
  customer: Wrap;
  other: Wrap;
  public init() {
    super.init();
    this.watch();
    this.customer = new Wrap(this, 'customer')
    this.other = new Wrap(this, 'other')
    this.listenMount([this.onMountTag])
  }
  public onMountTag(){
    this.updateJSON()
  }
  public updateJSON(){
    let json = {
      customer: this.stringArray(this.customer.items),
      other: this.stringArray(this.other.items)
    }
    let value = JSON.stringify(json)
    this.dispatch({ value: value })
  }
  public stringArray(items){
    let array = []
    for(let i = 0; i < items.length; i++){
      if(items[i].value != ''){ array.push(items[i].value) }
    }
    return array
  }
  public onChangeText(wrap: Wrap){
    return (e) => { wrap.onChangeText(e) }
  }
  public onChangeCheckbox(wrap: Wrap){
    return (e) => { wrap.onChangeCheckbox(e) }
  }
}

riot.mixin('inputs.complex.check-special-reports', ComplexCheckSpecialReports as riot.TagMixin)
